import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common from './locales/en/common.json';
import home from './locales/en/home.json';
import episodes from './locales/en/episodes.json';
import episodeDetail from './locales/en/episodeDetail.json';
import about from './locales/en/about.json';
import community from './locales/en/community.json';
import notFound from './locales/en/notFound.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'home', 'episodes', 'episodeDetail', 'about', 'community', 'notFound'],
  resources: {
    en: {
      common,
      home,
      episodes,
      episodeDetail,
      about,
      community,
      notFound,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
